import { $api } from '@service/RequestService';
import { DATE_FORMAT } from '@utils/constants';
import dayjs from 'dayjs';
import queryString from 'query-string';
import { useQuery } from 'react-query';
import { NumericArrayParam, StringParam, useQueryParams } from 'use-query-params';

import { TimelineModel, TimelineResModel, WidgetBodyModel } from '../models';

export function useTimelineWidget({ id, body, filterKey }: { body: WidgetBodyModel; id: number; filterKey: string }) {
  const [query] = useQueryParams({
    startDate: StringParam,
    finishDate: StringParam,
    responsibleByIds: NumericArrayParam
  });

  const finishDate = dayjs().endOf('week').add(1, 'day').format(DATE_FORMAT);
  const startDate = dayjs().startOf('week').add(1, 'day').format(DATE_FORMAT);

  const parseQuery = queryString.stringify({
    finishDate: body?.[filterKey as keyof typeof body]?.finishDate || query?.finishDate || finishDate,
    startDate: body?.[filterKey as keyof typeof body]?.startDate || query?.startDate || startDate,
    responsibleByIds: query?.responsibleByIds
  });

  const { data, ...arg } = useQuery<TimelineResModel[], unknown, TimelineModel[]>(
    ['dashboard-v2-time-line', id, parseQuery],
    async () => {
      const { data } = await $api.post(`/v1/dashboard/widget/time-line${parseQuery ? `?${parseQuery}` : ''}`, body);

      return data?.data;
    },
    {
      enabled: !!body?.dashboardId,
      select: data =>
        data?.map(({ count, time, amount }, key) => ({
          key,
          y: (body?.amountType ? amount : count) || 0,
          x: time
        }))
    }
  );

  const count = data?.reduce((a, b) => (a = (b?.y || 0) + a), 0);

  return { times: data, count, ...arg };
}
